<template>
  <v-card round outlined elevation='6' class="seat" :class="getCssClass()">
    <v-card-text class="no-pad poker-player">
      <div :class="['poker-cards']">
        <template v-if="hasShowableCards(player)[0]">
          <poker-card :class="['card', getFoldedClass(player)]" v-for="card in player.cards" :key="card" :card="card"></poker-card>
          <template v-if="hasShowableCards(player)[1]">*</template>
        </template>
        <template v-else>
          <poker-card :class="['card', getFoldedClass(player)]" v-for="k in numCards(player)" :key="k" card="card-back"></poker-card>
        </template>
      </div>
      <div class="bb" v-if="getOpponentCode(player.name)">
        <span>{{ formatNumber(getBB(getOpponentCode(player.name)), 0) }} / {{ getHands(getOpponentCode(player.name)) }}</span>
      </div>
      <div class="dealer" v-if="player.dealer">
        <span>D</span>
      </div>
      <div class="name">{{ player.name }}</div>
<!--      <div class="action" v-if="getAction()">{{ getAction() }}</div>-->
      <div>{{ formatNumber(player.stack) }}</div>
      <div>
        <span :style="`color: ${player.result > 0 ? '#80f645' : '#db3947'}`">
          <strong style="text-shadow: 1px 1px black;">{{ formatNumber(player.result) }}</strong>
        </span>
      </div>
<!--      <div v-if="player.sitout">(sitting out)</div>-->
<!--      <div class="chips" v-if="player.chips">{{ getChips() }}</div>-->
    </v-card-text>
  </v-card>
</template>

<script>
import PokerCard from "../PokerCard";
import {mapGetters} from "vuex";
export default {
  name: "PokerHandPlayer",
  components: {PokerCard},
  props: ["player"],

  data() {
    return {

    }
  },

  mounted() {

  },

  computed: {
    accountState() {
      if (!this.states) return {};
      if (!(this.activeChatAccountName in this.states)) return {};
      return this.states[this.activeChatAccountName];
    },
    ...mapGetters([
        'states',
        'opponents',
        'gameType',
        'activeChatAccountName',
        'isAdmin',
        'isOursByPlayerID'
    ])
  },

  methods: {
    getOpponentCode(name) {
      let state = this.accountState;
      if (!state) return null;

      for (let k in state.players) {
        if (state.players[k].name === name) {
          return state.players[k].code;
        }
      }
      return null;
    },

    getOpponentId(name) {
      let state = this.accountState;
      if (!state) return null;

      for (let k in state.players) {
        if (state.players[k].name === name) {
          return state.players[k].id;
        }
      }
      return null;
    },

    getCssClass() {
      let player = this.player;
      var target_seat = player.seat;

      if (player.ourSeat >= 0) {
        target_seat = (11 + player.seat - player.ourSeat) % 11;
      }
      var css = "seat-" + target_seat;

      if (player.result > 0) {
        css += " winner";
      }
      // if (this.state.active_seat === player.seat) {
      //   css += " active";
      // }

      if (this.isOursByPlayerID(this.getOpponentId(player.name))) {
        css += " is-our";
      }

      return css;
    },

    hasShowableCards(player) {
      if (player.cards.length === 0) {
        // no cards
        return [false, 0];
      }

      if (player.ourSeat === player.seat) {
        // our player
        return [true, 0];
      }

      if (player.showedCards) {
        // they showed
        return [true, 0];
      }

      if (this.isAdmin) {
        // admin
        return [true, 1];
      }

      // not
      return [false, 0];
    },

    getFoldedClass(player) {
      if (player.folded) {
        if (player.seat === player.ourSeat) {
          return 'folded-us';
        }
        return 'folded';
      }

      return '';
    },

    numCards(player) {
      let type = 'nlh';
      if (player.gameType) {
        type = player.gameType;
      } else {
        type = this.gameType(this.activeChatAccountName);
      }

      if (type === "nlh") {
        return 2;
      } else if (type === "plo5") {
        return 5;
      } else if (type === "plo6") {
        return 6;
      }
      return 4;
    },

    formatNumber(v, _d=2) {
      if (!v) return v;
      return (v).toFixed(_d).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    getHands(code) {
      if (!(code in this.opponents)) return "";
      let gameType = this.gameType(this.activeChatAccountName).toLowerCase();

      if (gameType === "plo4") {
        gameType = "plo";
      } else if (gameType === "plo5") {
        gameType = "plo5c";
      } else if (gameType === "plo6") {
        gameType = "plo6c";
      }

      let hands = this.opponents[code].hands[gameType];

      if (hands === 0) {
        return 0;
      }
      if (!hands) return "";

      let extra = "";

      if (hands >= 5000) {
        hands = Math.round(hands / 1000);
        hands = hands.toFixed(0);
        extra = "k";
      } else if (hands >= 1000) {
        hands = (hands / 1000).toFixed(1);
        extra = "k";
      }

      return hands.toString() + extra;
    },

    getBB(code) {
      if (!(code in this.opponents)) return "";
      let gameType = this.gameType(this.activeChatAccountName).toLowerCase();

      if (gameType === "plo4") {
        gameType = "plo";
      } else if (gameType === "plo5") {
        gameType = "plo5c";
      } else if (gameType === "plo6") {
        gameType = "plo6c";
      }

      return this.opponents[code].bbs[gameType];
    }
  }
}
</script>

<style scoped>

  .poker-player {
    width: 100%;
    height: 100%;

    font-size: .6vw;

    padding: 2%;
  }

  .name {
    font-size: 1.1em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .poker-cards {
    height: 70%;
    width: 100%;

    left: 0;
    right: 0;

    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;
    bottom: -75%;
  }

  .card {
    display: inline-flex;
    margin-left: 2% !important;
    max-width: 25%;
  }

  .dealer {
    display: flex;
    position: absolute;
    border-radius: 50%;

    justify-content: center;
    align-items: center;

    font-weight: bold;
    color: white;

    width: 25px;
    height: 25px;

    border: white 1px solid;
    background-color: black;

    right: 0;
    bottom: 0;
  }

  .bb {
    display: flex;
    position: absolute;
    border-radius: 4px;
    border: 1px solid white;

    justify-content: center;
    align-items: center;

    font-weight: bold;
    color: white;

    padding: 0 2px;

    background-color: black;

    left: -15px;
    bottom: 0;
  }

  .result {
    color: white;
    font-weight: bold;
    background-color: #303b3b;
    background-blend-mode: difference;
    border: 2px solid white;
    border-radius: 10px;
    padding: 2%;
    display: flex;
    position: absolute;

    font-size: .6vw;

    top: -20%;
    right: -10%;
  }

  .card >>> img {
    width: 100% !important;
    height: auto !important;
    object-fit: contain;
    object-position: top;
  }

  .seat {
    width: 22%;
    min-height: 70px;
    height: 20%;
    max-height: 20%;
    text-align: center;

    background-color: #232323;
    border: 1px solid #474747;
    border-radius: 4px;
  }

  .folded {
    opacity: .85;
  }

  .folded-us {
    border: 2px solid red;
  }

  .winner {

  }

  .is-our {
    border-color: limegreen;
    border-width: 2px;
  }

  .seat-0 {
    position: absolute;
    bottom: 5%;
    left: 0;
    right: 0;
    margin: auto;

    background-color: #344e58;
  }

  .seat-1 {
    position: absolute;
    bottom: 5%;

    left: 0;
    right: 60%;
    margin: auto;
  }

  .seat-2 {
    position: absolute;

    top: -7%;
    bottom: 0;

    margin: auto;

    left: 0;
  }

  .seat-3 {
    position: absolute;

    top: -3%;
    left: 0;
    right: 75%;

    margin: auto;
  }

  .seat-4 {
    position: absolute;

    top: -3%;

    left: 0;
    right: 25%;

    margin: auto;
  }

  .seat-5 {
    position: absolute;

    top: -3%;
    left: 25%;
    right: 0;

    margin: auto;
  }

  .seat-6 {
    position: absolute;

    top: -3%;
    left: 75%;
    right: 0;

    margin: auto;
  }

  .seat-7 {
    position: absolute;

    top: -7%;
    bottom: 0;

    margin: auto;

    right: 0;
  }

  .seat-8 {
    position: absolute;
    bottom: 5%;

    left: 60%;
    right: 0;
    margin: auto;
  }

  .seat-9 {
    position: absolute;

    top: -7%;
    bottom: 0;

    margin: auto;

    right: 10%;
  }

  .seat-10 {
    position: absolute;
    bottom: 5%;

    left: 30%;
    right: 30%;
    margin: auto;
  }
</style>
